const STORAGE_KEY = "robotic-arm-challenge-progress";

function readProgress() {
  try {
    const saved = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "{}");
    return saved && typeof saved === "object" ? saved : {};
  } catch (error) {
    console.warn("Could not read robotic arm challenge progress", error);
    return {};
  }
}

function writeProgress(progress) {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(progress));
}

export function challengeStatus(id) {
  const status = readProgress()[id];
  if (status === "completed" || status === "in-progress") return status;
  return "not-started";
}

export function markChallengeStarted(id) {
  const progress = readProgress();
  if (progress[id] === "completed" || progress[id] === "in-progress") return;
  progress[id] = "in-progress";
  writeProgress(progress);
}

export function markChallengeCompleted(id) {
  const progress = readProgress();
  if (progress[id] === "completed") return;
  progress[id] = "completed";
  writeProgress(progress);
}
